import SearchBar from "../Components/SearchBar";
import Title from "../Components/Title";
import { useSelector } from "react-redux";
import WhiteCard from "../Components/WhiteBox";
import OpenInNewRoundedIcon from '@mui/icons-material/OpenInNewRounded';
import { useNavigate } from "react-router-dom";

export default function MyPlace() {
  const navigate = useNavigate()
  const chron = makeChronAList(useSelector(state => state.chronology).list)
  
  chron.sort((prec, succ) => {
    if (succ.date > prec.date)
      return 1
    else if (succ.date == prec.date) {
      if (succ.time > prec.time)
        return 1
      else if (succ.time == prec.time) {
        return 0
      }
    }
    
    
    return -1
  })

  const handleSelectCity = (city) => {
    navigate('/city/' + city.id)
  }

  return (
    <div>
      <SearchBar />
      <div className="container">
        <Title title="Cronologia" />
        {
          chron.map(c =>
            <WhiteCard key={c.city.id} id={c.city} content={<p>{c.city.name }</p>} icon={<OpenInNewRoundedIcon />} selected={handleSelectCity} />
          )
        }
        {
          chron.length <= 0 ? 
            <><p>cronologia vuota<br /> cerca una città per cominciare</p></>
            :
            <></>
        }
      </div>
      <div style={{display: 'block', height:'70px'}}></div>
    </div>
  )
}

function makeChronAList(chron) {
  let ret = []
  for (let i in chron) {
    ret.push(chron[i])
  }
  return ret;
}